import { render, staticRenderFns } from "./gongshang.vue?vue&type=template&id=265e20bc&scoped=true"
import script from "./gongshang.vue?vue&type=script&lang=js"
export * from "./gongshang.vue?vue&type=script&lang=js"
import style0 from "./gongshang.vue?vue&type=style&index=0&id=265e20bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265e20bc",
  null
  
)

export default component.exports